import { DateTime } from "luxon";
import { US_FEDERAL_HOLIDAYS } from "./us-federal-holidays";

/**
 * Provides a function to check if a a date is a USA federal holiday
 *
 * CRB ACH Docs Say:
 * - ACH transactions settle on business days. There is no settlement on weekends or federal holidays.
 * - Transactions occur on business days. There is no support on weekends or banking holidays.
 * @see https://docs.crossriver.com/Content/Payments/ACH/ACH_Guides/ACHoverview.html#ACHatCrossRiver
 * @see https://www.federalreserve.gov/aboutthefed/k8.htm
 */
export const isUSFederalHoliday = (date: DateTime) => {
  // Convert the Luxon DateTime to a JavaScript Date
  const jsDate = date.setZone("UTC").toJSDate();

  // Check if the date is a US Federal holiday
  const holidays = US_FEDERAL_HOLIDAYS.isHoliday(jsDate);

  // If holidays is not false, it's a holiday
  return holidays !== false;
};
